var LGFG = LGFG || {};
LGFG.WF = LGFG.WF || {};

LGFG.WF.FenceDesigner = LGFG.WF.FenceDesigner || (function () {
    var scrollToAnchor=function(aid){
        var aTag = $("a[name='"+ aid +"']");
        $('html,body').animate({scrollTop: aTag.offset().top-120},'slow');
    };

    var init = function () {
        document.getElementById('distributor-locator-map').addEventListener('select', function (e) {
            $.ajax({
                url: '/wffencedesign/selectdistributor',
                method: 'POST',
                data: { 'distributorID': e.detail }
            }).done(function () {
                $.ajax({
                    url: '/wffencedesign/selecteddistributors',
                }).done(function (html) {
                    $('.js-selected-distributors-list').html(html);
                    scrollToAnchor('a-selected-distributors');
                    $('.js-remove-distributor').bind('click', function () {
                        $.ajax({
                            url: '/wffencedesign/deselectdistributor',
                            method: 'POST',
                            data: { 'distributorID': $(this).closest('.selected-distributor').data('distributorid') }
                        }).done(function () {
                            $.ajax({
                                url: '/wffencedesign/selecteddistributors',
                            }).done(function (html) {
                                $('.js-selected-distributors-list').html(html);
                                scrollToAnchor('a-selected-distributors');
                            });
                        });
                    });
                });
            });
        });

    };
    return {
        init: init
    };
})();